import React, { PureComponent } from 'react';
import { Trans, t } from '@lingui/macro';

import Chart from '../utils/chartjs';
import chartOptionsGen from '../utils/chartOptionsGen';
import { weekdayTranslate } from '../utils';

class SystemMovingTimeWday extends PureComponent {
    constructor(props) {
        super(props);
        this.graphRefs = React.createRef();
        this.height = props.isMobile ? '200px' : '250px';
    }

    componentDidMount() {
        this.drawChart();
    }

    componentWillReceiveProps() {
        this.drawChart();
    }

    drawChart = () => {
        const { data, locale } = this.props;
        const labels = Object.keys(data).map((wday) => weekdayTranslate(locale, wday));
        const datasets = Object.values(data).map((d) => Math.round(d / 60)); // second -> minute
        if (this.chart) {
            this.chart.data.datasets = this._genDatasets(datasets);
            this.chart.update();
        } else {
            const ctx = this.graphRefs.current.getContext('2d');
            this.chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels,
                    datasets: this._genDatasets(datasets),
                },
                options: {
                    indexAxis: 'y',
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 10,
                                },
                            },
                        ],
                    },
                    tooltips: {
                        callbacks: {
                            title: (tooltipItem) => {
                                const { xLabel, yLabel } = tooltipItem[0];
                                return `${yLabel}: ${xLabel} ${t({ id: 'common.minutes' })}`;
                            },
                            label: () => null,
                        },
                    },
                },
            });
        }
    }

    _genDatasets = (datasets) => [
        chartOptionsGen.genData({
            data: datasets,
            bkgColor: 'rgba(54, 162, 235, 1)',
            borderColor: 'rgba(54, 162, 235, 1)',
            hoverBackgroundColor: 'rgba(54, 162, 235, 1)',
            hoverBorderColor: 'rgba(54, 162, 235, 1)',
            label: t({ id: 'common.minutes' }),
        }),
    ]

    render() {
        return (
            <div className="mb-3">
                <h4 className="system-head" style={{ textAlign: 'left' }}>
                    <Trans id="system.tripDurationWday" />
                </h4>
                <div style={{ position: 'relative', height: this.height }}>
                    <canvas ref={this.graphRefs} />
                </div>
            </div>
        );
    }
}
export default (SystemMovingTimeWday);
